import React, { useState, useEffect } from "react";
import CtaLayout from "./CtaLayout";
import "../../styles/common.css";
import "../../styles/cta.css";

function CtaWebsite() {

  return (
    <>
      <CtaLayout title="Contact Us" lead="CONTACT">
        <div className='cta-box__text'>
          <h3>Please consult with us from the "specification decision" phase.</h3>
          <p>At LOGOT, we offer free consultations to provide suggestions from the "specification" aspects, including marketing strategies, actual site structure, design, and functionality. <br />We welcome inquiries from those who are uncertain about site renewal, so please feel free to contact us first.</p>
        </div>
      </CtaLayout>
    </>
  );
}

export default CtaWebsite;
